import type { ComponentType } from 'react'
import { DomainEnum } from '@strata-monorepo/shared-types/src/Domain'
import CtxpLogo from '../constants/logos/CtxpLogo'
import CtxpLogoMark from '../constants/logos/CtxpLogoMark'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

/**
 * Logo rendering variant: the full wordmark logo or the compact, mark-only
 * logo (icon without the wordmark) used for narrow layouts such as the mobile header.
 */
export type LogoVariant = 'full' | 'mark'

/**
 * Maps a domain from DomainEnum to its corresponding logo component
 *
 * @param domain - The domain from DomainEnum to map to a logo
 * @param variant - Which logo variant to return ('full' wordmark or compact 'mark')
 * @returns The appropriate logo component or null
 */
export function getLogoFromDomain(
  domain: DomainEnum | null,
  variant: LogoVariant = 'full',
): ComponentType<IconProps> | null {
  if (!domain) return null

  switch (domain) {
    case DomainEnum.CTXP:
      return variant === 'mark' ? CtxpLogoMark : CtxpLogo
    case DomainEnum.TXER:
    case DomainEnum.SOE:
    case DomainEnum.CHOOSE:
      // TODO: Add other logo components when they're created
      return null
    default:
      return null
  }
}
